const translations = {
  hr: {
    // Common
    loading: "Učitavanje...",
    error: "Greška",
    cancel: "Odustani",
    save: "Spremi",
    delete: "Obriši",
    confirm: "Potvrdi",
    back: "Nazad",
    close: "Zatvori",
    info: "Info",
    tip: "Savjet",
    or: "ILI",
    download: "Preuzmi",
    
    // Auth
    adminLogin: "Admin Login",
    loginSubtitle: "Prijavite se za pristup",
    email: "Email",
    password: "Lozinka",
    loginBtn: "Prijavi se",
    loggingIn: "Prijava...",
    loginError: "Greška pri prijavi",
    
    // Age Verification
    ageTitle: "Provjera dobi",
    ageDescription: "Ovaj sadržaj je namijenjen samo za osobe starije od 18 godina.",
    ageEntering: "Ulaskom na ovu stranicu potvrđujete da:",
    ageOver18: "Imate 18 ili više godina",
    ageConsent: "Pristajete na pregled sadržaja za odrasle",
    ageAI: "Razumijete da je sadržaj generiran umjetnom inteligencijom",
    ageConfirm: "Potvrđujem da imam 18+ godina",
    ageEnter: "Ulaz",
    
    // Landing
    heroTitle1: "Kreirajte svog",
    heroTitle2: "savršenog AI modela",
    heroDescription: "Napredni AI generator slika za kreiranje jedinstvenih virtualnih persona. Potpuna kontrola nad stilom, izgledom i karakterom.",
    startCreating: "Započni kreiranje",
    learnMore: "Saznaj više",
    featureImages: "Ultra-realistične slike",
    featureImagesDesc: "GPT Image 1 tehnologija za fotorealistične rezultate",
    featureControl: "Potpuna kontrola",
    featureControlDesc: "Definirajte svaki detalj vašeg AI modela",
    featureGallery: "Privatna galerija",
    featureGalleryDesc: "Spremite i upravljajte svim generiranim slikama",
    
    // Dashboard
    dashboard: "Dashboard",
    myModels: "Moji modeli",
    home: "Početna",
    newModel: "Novi model",
    noModels: "Nemate još modela",
    createFirst: "Kreirajte svoj prvi AI model",
    deleteModelTitle: "Brisanje modela",
    deleteModelDesc: "Jeste li sigurni? Ovo će obrisati model i sve generirane slike.",
    modelDeleted: "Model uspješno obrisan",
    
    // Model Form
    createModel: "Kreiraj novog AI modela",
    editModel: "Uredi model",
    modelName: "Ime modela",
    description: "Opis",
    gender: "Spol",
    female: "Žensko",
    male: "Muško",
    ageRange: "Dobna skupina",
    hairColor: "Boja kose",
    hairStyle: "Stil kose",
    eyeColor: "Boja očiju",
    bodyType: "Tip tijela",
    ethnicity: "Etnicitet",
    style: "Stil",
    personality: "Osobnost",
    matureContent: "Mature sadržaj (18+)",
    matureDesc: "Omogući generiranje sadržaja za odrasle",
    initialImages: "Početne slike",
    creating: "Kreiranje...",
    updating: "Ažuriranje...",
    bodyReferences: "Tjelesne reference",
    addBodyRef: "Dodaj referensu",
    referenceImage: "Referentna slika",
    setAsReference: "Postavi kao referentnu sliku",
    removeReference: "Ukloni referencu",
    
    // Model Detail
    generateImage: "Generiraj sliku",
    generateVideo: "Generiraj video",
    images: "Slike",
    videos: "Videi",
    generating: "Generiranje...",
    
    // Generate Dialog
    additionalPrompt: "Dodatni prompt (opcionalno)",
    promptPlaceholder: "npr. u večernjoj haljini, na plaži, profesionalni portret...",
    matureToggle: "Mature sadržaj",
    matureToggleDesc: "Senzualni sadržaj za odrasle (odjeveni)",
    nsfwModel: "NSFW Model",
    nsfwNinjaChat: "NinjaChat (konzistentnost lika aktivna)",
    nsfwVenice: "Venice AI (bez cenzure modela)",
    nudityToggle: "Golotinja",
    nudityDesc: "Eksplicitna golotinja — bez ograničenja odjeće",
    nsfwNoNudityInfo: "NSFW model je aktivan ali golotinja je isključena — slike će biti senzualne ali odjevene.",
    referenceActiveInfo: "Referentna slika je aktivna - slika će imati isti lik. Za potpuno novi lik, uklonite referentnu sliku.",
    useBodyRef: "Koristi tjelesnu referencu",
    bodyRefStrength: "Snaga reference",
    naturalQuality: "Prirodna kvaliteta",
    naturalQualityDesc: "Fotorealistična kvaliteta bez AI izgleda",
    batchMode: "5 varijacija",
    batchModeDesc: "Generiraj 5 slika s različitim kutovima",
    generate: "Generiraj",
    
    // Presets
    presetGlamour: "Glamurozni portret",
    presetBeach: "Na plaži",
    presetEvening: "Večernja haljina",
    presetSport: "Sportski outfit",
    presetOffice: "Uredski look",
    presetCasual: "Kućni casual",
    presetSelfie: "Selfie",
    presetFitness: "Fitness poza",
    presetBed: "Na krevetu",
    presetSummer: "Ljetna haljina",
    presetPool: "Pool party",
    presetNight: "Noćni izlazak",
    
    // Selfie picker
    selfiePickerTitle: "Odaberi lokaciju za selfie:",
    selfiePickerHint: "AI će automatski složiti pravi POV selfie kompoziciju.",
    selfieLoc_office: "Ured",
    selfieLoc_cafe: "Kafić",
    selfieLoc_car: "Auto",
    selfieLoc_beach: "Plaža",
    selfieLoc_bedroom: "Spavaća soba",
    selfieLoc_bathroom: "Kupaonica",
    selfieLoc_park: "Park",
    selfieLoc_restaurant: "Restoran",
    selfieLoc_gym: "Teretana",
    selfieLoc_pool: "Bazen",
    selfieLoc_street: "Ulica",
    selfieLoc_home: "Kod kuće",
    
    // Strict Face Mode
    strictFaceMode: "Strict Face Mode",
    strictFaceModeDesc: "Maksimalno očuvanje lica — 0 drifta",
    strictFaceModeHint: "Forsira strength=0.15 za NinjaChat. Manje promjene scene, ali lice 100% identično referenci. Idealno za portfolio/marketing slike.",
    
    // Hard Nudity Mode
    hardNudity: "Hardcore Mod",
    hardNudityDesc: "Eksplicitne slike s istim licem (2-stage: Venice + face-swap)",
    hardNudityHint: "⚠️ TIJELO ĆE BITI DRUGAČIJE (Venice generira novo tijelo). Samo lice ostaje isto. Za isto lice + isto tijelo + soft semi-nude (boudoir), ISKLJUČI Hardcore i koristi samo Mature + Golotinja toggle. Traje ~3-5 min. Skuplje.",
    
    presetGlamourPrompt: "glamurozni portret, profesionalno osvjetljenje, studijska fotografija",
    presetBeachPrompt: "na plaži, zalazak sunca, prirodno svjetlo, opuštena poza",
    presetEveningPrompt: "u elegantnoj večernjoj haljini, luksuzni interijer, filmsko osvjetljenje",
    presetSportPrompt: "u sportskoj odjeći, teretana, energična poza, fitness stil",
    presetOfficePrompt: "u poslovnoj odjeći, moderan ured, profesionalni portret",
    presetCasualPrompt: "u kućnoj odjeći, udoban kauč, opuštena atmosfera, mekano svjetlo",
    presetSelfiePrompt: "selfie u ogledalu, kupaonica, prirodna poza, mobilni telefon u ruci",
    presetFitnessPrompt: "fitness fotografija, definirana muskulatura, sportski grudnjak i tajice, teretana u pozadini",
    presetBedPrompt: "na krevetu, mekana posteljina, intimno osvjetljenje, opuštena poza",
    presetSummerPrompt: "u laganoj ljetnoj haljini, cvijetna livada, sunčan dan, prirodna ljepota",
    presetPoolPrompt: "kraj bazena, kupaći kostim, sunčano vrijeme, ljetna atmosfera",
    presetNightPrompt: "u klubu, neonska svjetla, zavodljiva poza, elegantna odjeća",
    
    // Video Dialog
    videoModel: "Video model",
    bestQuality: "Najbolja kvaliteta",
    faster: "Kraći timeout",
    videoPrompt: "Prompt za pokret",
    videoPromptPlaceholder: "npr. slowly turns head and smiles",
    videoInfo: "Seedance 1.5 Pro daje kvalitetne video rezultate. Pišite promptove samo za pokret, ne opisujte izgled osobe.",
    generateVideoBtn: "Generiraj Video",
    videoGenerating: "Generiranje videa...",
    
    // Lipsync Dialog
    lipsyncTitle: "Generiraj Lipsync Video",
    lipsyncDesc: "Generirajte govor iz teksta ili unesite audio URL",
    generateSpeech: "Generiraj govor iz teksta",
    ttsTextPlaceholder: "Unesite tekst koji želite pretvoriti u govor...",
    voice: "Glas",
    quality: "Kvaliteta",
    hdQuality: "HD (bolja kvaliteta)",
    standardQuality: "Standard (brže)",
    generateSpeechBtn: "Generiraj govor",
    generatingSpeech: "Generiranje govora...",
    listenPreview: "Preslušajte generirani govor:",
    audioUrlManual: "Audio URL (ručni unos)",
    audioUrlPlaceholder: "https://example.com/audio.mp3",
    audioUrlDesc: "Direktan link na MP3 ili WAV audio datoteku",
    audioReady: "Audio spreman za lipsync!",
    lipsyncTip: "Za najbolje rezultate koristite čist govor bez pozadinske glazbe. Audio do 60 sekundi.",
    generateLipsync: "Generiraj Lipsync",
    lipsyncGenerating: "Generiranje...",
    lipsyncStarted: "Lipsync generiranje pokrenuto (2 koraka). Provjeravajte Video tab!",
    
    // Talking Video
    talkingTitle: "Govoreći Video",
    talkingDesc: "3 koraka: Govor → Prirodni pokreti → Lipsync sinkronizacija",
    talkingTextLabel: "Tekst za govor *",
    talkingTextPlaceholder: "Unesite što želite da lik kaže...",
    movement: "Pokret",
    movementNatural: "Prirodni (lagani)",
    movementEnergetic: "Energični",
    movementMinimal: "Minimalni (intervju)",
    movementPlayful: "Zaigrani",
    howItWorks: "Kako radi:",
    step1: "1. Generira govor iz teksta (TTS)",
    step2: "2. Generira video s prirodnim pokretima (Venice AI)",
    step3: "3. Sinkronizira usne s govorom (Fal.ai Sync Lipsync)",
    duration: "Trajanje: ~3-5 minuta",
    generateTalkingBtn: "Generiraj Govoreći Video",
    talkingStarting: "Pokretanje...",
    talkingStarted: "Govoreći video se generira (3 koraka). Provjeravajte Video tab!",
    
    // ElevenLabs voices
    myVoice: "Moj glas (custom)",
    
    // Video status
    videoProcessing: "Obrada...",
    videoFailed: "Generiranje neuspješno",
    
    // Toasts
    imageGenerated: "Slika uspješno generirana!",
    nsfwImageGenerated: "NSFW slika uspješno generirana!",
    envImageGenerated: "Slika s okolinom generirana!",
    ninjaWarning: "NinjaChat nedostupan — lice možda nije identično referenci. Pokušajte ponovo kasnije za bolju konzistentnost.",
    imageDownloaded: "Slika preuzeta!",
    videoDownloaded: "Video preuzimanje pokrenuto!",
    speechGenerated: "Govor generiran!",
    modelCreated: "Model uspješno kreiran!",
    modelUpdated: "Model uspješno ažuriran!",
    errorLoading: "Greška pri učitavanju",
    retryThumbnail: "Thumbnail postavljen",
    
    // Language
    language: "Jezik",
  },
  
  en: {
    // Common
    loading: "Loading...",
    error: "Error",
    cancel: "Cancel",
    save: "Save",
    delete: "Delete",
    confirm: "Confirm",
    back: "Back",
    close: "Close",
    info: "Info",
    tip: "Tip",
    or: "OR",
    download: "Download",
    
    // Auth
    adminLogin: "Admin Login",
    loginSubtitle: "Sign in to access",
    email: "Email",
    password: "Password",
    loginBtn: "Sign In",
    loggingIn: "Signing in...",
    loginError: "Login failed",
    
    // Age Verification
    ageTitle: "Age Verification",
    ageDescription: "This content is intended for persons aged 18 and over only.",
    ageEntering: "By entering this page you confirm that:",
    ageOver18: "You are 18 years or older",
    ageConsent: "You consent to viewing adult content",
    ageAI: "You understand that content is AI-generated",
    ageConfirm: "I confirm I am 18+ years old",
    ageEnter: "Enter",
    
    // Landing
    heroTitle1: "Create your",
    heroTitle2: "perfect AI model",
    heroDescription: "Advanced AI image generator for creating unique virtual personas. Full control over style, appearance, and character.",
    startCreating: "Start Creating",
    learnMore: "Learn More",
    featureImages: "Ultra-realistic Images",
    featureImagesDesc: "GPT Image 1 technology for photorealistic results",
    featureControl: "Full Control",
    featureControlDesc: "Define every detail of your AI model",
    featureGallery: "Private Gallery",
    featureGalleryDesc: "Save and manage all generated images",
    
    // Dashboard
    dashboard: "Dashboard",
    myModels: "My Models",
    home: "Home",
    newModel: "New Model",
    noModels: "No models yet",
    createFirst: "Create your first AI model",
    deleteModelTitle: "Delete Model",
    deleteModelDesc: "Are you sure? This will delete the model and all generated images.",
    modelDeleted: "Model deleted successfully",
    
    // Model Form
    createModel: "Create New AI Model",
    editModel: "Edit Model",
    modelName: "Model Name",
    description: "Description",
    gender: "Gender",
    female: "Female",
    male: "Male",
    ageRange: "Age Range",
    hairColor: "Hair Color",
    hairStyle: "Hair Style",
    eyeColor: "Eye Color",
    bodyType: "Body Type",
    ethnicity: "Ethnicity",
    style: "Style",
    personality: "Personality",
    matureContent: "Mature Content (18+)",
    matureDesc: "Enable adult content generation",
    initialImages: "Initial Images",
    creating: "Creating...",
    updating: "Updating...",
    bodyReferences: "Body References",
    addBodyRef: "Add Reference",
    referenceImage: "Reference Image",
    setAsReference: "Set as Reference",
    removeReference: "Remove Reference",
    
    // Model Detail
    generateImage: "Generate Image",
    generateVideo: "Generate Video",
    images: "Images",
    videos: "Videos",
    generating: "Generating...",
    
    // Generate Dialog
    additionalPrompt: "Additional Prompt (optional)",
    promptPlaceholder: "e.g. in an evening dress, at the beach, professional portrait...",
    matureToggle: "Mature Content",
    matureToggleDesc: "Sensual adult content (clothed)",
    nsfwModel: "NSFW Model",
    nsfwNinjaChat: "NinjaChat (character consistency active)",
    nsfwVenice: "Venice AI (uncensored model)",
    nudityToggle: "Nudity",
    nudityDesc: "Explicit nudity — no clothing restrictions",
    nsfwNoNudityInfo: "NSFW model is active but nudity is off — images will be sensual but clothed.",
    referenceActiveInfo: "Reference image is active — image will have the same character. Remove reference for a completely new character.",
    useBodyRef: "Use Body Reference",
    bodyRefStrength: "Reference Strength",
    naturalQuality: "Natural Quality",
    naturalQualityDesc: "Photorealistic quality without AI look",
    batchMode: "5 Variations",
    batchModeDesc: "Generate 5 images with different angles",
    generate: "Generate",
    
    // Presets
    presetGlamour: "Glamour Portrait",
    presetBeach: "Beach",
    presetEvening: "Evening Dress",
    presetSport: "Sport Outfit",
    presetOffice: "Office Look",
    presetCasual: "Home Casual",
    presetSelfie: "Selfie",
    presetFitness: "Fitness Pose",
    presetBed: "On the Bed",
    presetSummer: "Summer Dress",
    presetPool: "Pool Party",
    presetNight: "Night Out",
    
    // Selfie picker
    selfiePickerTitle: "Choose selfie location:",
    selfiePickerHint: "AI will automatically compose a proper POV selfie shot.",
    selfieLoc_office: "Office",
    selfieLoc_cafe: "Cafe",
    selfieLoc_car: "Car",
    selfieLoc_beach: "Beach",
    selfieLoc_bedroom: "Bedroom",
    selfieLoc_bathroom: "Bathroom",
    selfieLoc_park: "Park",
    selfieLoc_restaurant: "Restaurant",
    selfieLoc_gym: "Gym",
    selfieLoc_pool: "Pool",
    selfieLoc_street: "Street",
    selfieLoc_home: "At Home",
    
    // Strict Face Mode
    strictFaceMode: "Strict Face Mode",
    strictFaceModeDesc: "Maximum face preservation — 0 drift",
    strictFaceModeHint: "Forces strength=0.15 for NinjaChat. Less scene change, but face is 100% identical to reference. Ideal for portfolio/marketing shots.",
    
    // Hard Nudity Mode
    hardNudity: "Hardcore Mode",
    hardNudityDesc: "Explicit images with same face (2-stage: Venice + face-swap)",
    hardNudityHint: "⚠️ BODY WILL BE DIFFERENT (Venice generates a new body). Only face stays the same. For same face + same body + soft semi-nude (boudoir), DISABLE Hardcore and use only Mature + Nudity toggle. Takes ~3-5 min. More expensive.",
    
    presetGlamourPrompt: "glamour portrait, professional lighting, studio photography",
    presetBeachPrompt: "at the beach, sunset, natural light, relaxed pose",
    presetEveningPrompt: "in an elegant evening dress, luxury interior, cinematic lighting",
    presetSportPrompt: "in sportswear, gym, energetic pose, fitness style",
    presetOfficePrompt: "in business attire, modern office, professional portrait",
    presetCasualPrompt: "in casual home clothes, cozy couch, relaxed atmosphere, soft light",
    presetSelfiePrompt: "mirror selfie, bathroom, natural pose, phone in hand",
    presetFitnessPrompt: "fitness photography, defined muscles, sports bra and leggings, gym background",
    presetBedPrompt: "on the bed, soft bedding, intimate lighting, relaxed pose",
    presetSummerPrompt: "in a light summer dress, flower meadow, sunny day, natural beauty",
    presetPoolPrompt: "by the pool, swimsuit, sunny weather, summer atmosphere",
    presetNightPrompt: "in the club, neon lights, seductive pose, elegant outfit",
    
    // Video Dialog
    videoModel: "Video Model",
    bestQuality: "Best quality",
    faster: "Shorter timeout",
    videoPrompt: "Movement Prompt",
    videoPromptPlaceholder: "e.g. slowly turns head and smiles",
    videoInfo: "Seedance 1.5 Pro delivers quality video results. Write prompts for movement only, don't describe appearance.",
    generateVideoBtn: "Generate Video",
    videoGenerating: "Generating video...",
    
    // Lipsync Dialog
    lipsyncTitle: "Generate Lipsync Video",
    lipsyncDesc: "Generate speech from text or enter an audio URL",
    generateSpeech: "Generate Speech from Text",
    ttsTextPlaceholder: "Enter the text you want to convert to speech...",
    voice: "Voice",
    quality: "Quality",
    hdQuality: "HD (better quality)",
    standardQuality: "Standard (faster)",
    generateSpeechBtn: "Generate Speech",
    generatingSpeech: "Generating speech...",
    listenPreview: "Listen to generated speech:",
    audioUrlManual: "Audio URL (manual input)",
    audioUrlPlaceholder: "https://example.com/audio.mp3",
    audioUrlDesc: "Direct link to MP3 or WAV audio file",
    audioReady: "Audio ready for lipsync!",
    lipsyncTip: "For best results use clean speech without background music. Audio up to 60 seconds.",
    generateLipsync: "Generate Lipsync",
    lipsyncGenerating: "Generating...",
    lipsyncStarted: "Lipsync generation started (2 steps). Check the Videos tab!",
    
    // Talking Video
    talkingTitle: "Talking Video",
    talkingDesc: "3 steps: Speech → Natural Movement → Lipsync Sync",
    talkingTextLabel: "Text for Speech *",
    talkingTextPlaceholder: "Enter what you want the character to say...",
    movement: "Movement",
    movementNatural: "Natural (gentle)",
    movementEnergetic: "Energetic",
    movementMinimal: "Minimal (interview)",
    movementPlayful: "Playful",
    howItWorks: "How it works:",
    step1: "1. Generates speech from text (TTS)",
    step2: "2. Generates video with natural movements (Venice AI)",
    step3: "3. Syncs lips with speech (Fal.ai Sync Lipsync)",
    duration: "Duration: ~3-5 minutes",
    generateTalkingBtn: "Generate Talking Video",
    talkingStarting: "Starting...",
    talkingStarted: "Talking video is generating (3 steps). Check the Videos tab!",
    
    // ElevenLabs voices
    myVoice: "My Voice (custom)",
    
    // Video status
    videoProcessing: "Processing...",
    videoFailed: "Generation failed",
    
    // Toasts
    imageGenerated: "Image generated successfully!",
    nsfwImageGenerated: "NSFW image generated successfully!",
    envImageGenerated: "Image with environment generated!",
    ninjaWarning: "NinjaChat unavailable — face may not match reference. Try again later for better consistency.",
    imageDownloaded: "Image downloaded!",
    videoDownloaded: "Video download started!",
    speechGenerated: "Speech generated!",
    modelCreated: "Model created successfully!",
    modelUpdated: "Model updated successfully!",
    errorLoading: "Error loading data",
    retryThumbnail: "Thumbnail set",
    
    // Language
    language: "Language",
  }
};

export default translations;
